














import { Component, Vue} from 'vue-property-decorator';

@Component({
  name: 'AgroFooter',
})
export default class AgroFooter extends Vue {}
